﻿import { StaticSchema } from "./StaticSchema";

var BASE_URL = '/api/Schema';

export function getSchema(callback: (err: any, data: StaticSchema) => any): void {
    $.ajax(BASE_URL + '/Get', {
        cache: false,
        dataType: 'json',
        type: 'GET',
        timeout: 120000,
        success: (data: StaticSchema, text: string, jqXHR: JQueryXHR) => {
            callback(null, data);
        },
        error: (jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => {
            callback(errorThrown, null);
        }
    });
}